
<template>
  <div class="accordion">
    <button class="accordion-opener" @click="toggleAccordion">
      {{ label }}
      <div
        class="accordion-opener-arrow"
        :class="{ 'arrow-rotate': show }"
      />
    </button>
    <transition
      name="accordion"
      @enter="enter"
      @after-enter="afterEnter"
      @leave="leave"
    >
      <div class="accordion-container" v-if="show">
        <slot />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name:"Accordion",
  props: {
    label: {
      type: String,
      default: 'Click me!',
    },
  },

  data() {
    return {
      show: false,
    }
  },

  methods: {
    toggleAccordion() {
      this.show = !this.show;
    },

    afterEnter(element) {
      element.style.height = `auto`;
    },

    enter(element) { //TBD Destructuring
      const { width } = getComputedStyle(element);
      element.style.width = width;
      element.style.position = `absolute`;
      element.style.visibility = `hidden`;
      element.style.height = `auto`;
      const { height } = getComputedStyle(element);
      element.style.width = null;
      element.style.position = null;
      element.style.visibility = null;
      element.style.height = 0;
      getComputedStyle(element).height;
      requestAnimationFrame(() => {
        element.style.height = height;
      });
    },

    leave(element) { //TBD Destructuring
      const { height } = getComputedStyle(element);
      element.style.height = height;
      getComputedStyle(element).height;
      requestAnimationFrame(() => {
        element.style.height = 0;
      });
    },
  },
}
</script>

<style lang="scss" scoped>
.accordion {
  margin: 0px 20px 20px 20px;

  &-opener {
    font-family: Futura W01;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 30px;
    letter-spacing: 0.15px;
    text-align: left;
    background: $color-super-light-blue;
    border: none;
    display: block;
    width: 100%;
    padding: 12px 16px;
    color: $color-blue;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-radius: 10px;

    &-arrow {
      position: relative;
      height: 20px;
      width: 20px;
      transition: transform .2s ease-in-out;

      &.arrow-rotate {
        transition: transform .2s ease-in-out;
        transform: rotate(180deg);
      }

      &::after {
        content: "";
        position: absolute;
        background: $color-blue;
        height: 10px;
        width: 2px;
        right: calc(50% - 4px) ;
        top: 50%;
        margin-top: -5px;
        transform: rotate(45deg);
      }
      &::before {
        content: "";
        position: absolute;
        background: $color-blue;
        height: 10px;
        width: 2px;
        left: calc(50% - 4px);
        top: 50%;
        margin-top: -5px;
        transform: rotate(-45deg);
      }
    }
  }
}

.accordion-enter-active,
.accordion-leave-active {
  transition: height .2s ease-in-out;
  overflow: hidden;
}
.accordion-enter,
.accordion-leave-to {
  height: 0;
}
</style>